var facebookService = (function(window){
    return {
        api: function(path, method, params) {
            return new Promise(function(resolve, reject) {
                FB.api(path, method, params, function(response) {
                    console.log(response);
                    if ( response && !response.error ) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                });
            });
        },

        login: function(args) {
            return new Promise(function(resolve, reject) {
                FB.login(function(response){
                    console.log(response);
                    if ( response && !response.error_message) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                }, args);
            });
        },

        ui: function(args) {
            return new Promise(function(resolve, reject) {
                FB.ui(args, function(response){
                    if ( response && !response.error_message) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                });
            });
        }
    };
})(window);